import Vue from 'vue';
import Vuex from 'vuex';
import userStore from './modules/userStore';
import appStore from './modules/appStore';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    userStore,
    appStore,
  },
});
